export default __webpack_public_path__ + "static/media/News.c683fc14.png";